import {PayloadAction} from '@reduxjs/toolkit';

import {IRegistry} from 'shared/types';

import {ITableReportDataRequestParams, ITableReportDocumentUploadInfo, ITableReportSliceState} from '../table-report-slice-types';
import {
    TAnimationReportDownloadDocumentsParams,
    IModalReportDownloadDocumentType,
    IPaginationType, TReadReportDocumentsParams,
    ITableReportDownloadDocumentType,
} from './table-report-download-documents-types';

export const createTableReportDownloadDocumentsReducer = <S extends ITableReportSliceState>() => ({
    setReportDownloadsData(state: S, {payload}: PayloadAction<IRegistry<ITableReportDownloadDocumentType>>) {
        state.reportDownloadDocuments = {
            ...payload,
            modalReportDownloadDocument: {
                isOpen: false,
                wereDocumentsRead: true,
            },
        };
    },
    resetReportDownloadsData(state: S) {
        state.reportDownloadDocuments = undefined;
    },
    removeReportDownloads(state: S, {payload: ids}: PayloadAction<number[]>) {
        const changedReportDownloadDocuments = state.reportDownloadDocuments
            ?.content?.filter((report: any) => !ids.includes(report.requestId));
        if (changedReportDownloadDocuments && state.reportDownloadDocuments) {
            state.reportDownloadDocuments = {
                ...state.reportDownloadDocuments,
                content: changedReportDownloadDocuments,
            };
        }
    },
    setReportDocUploadInfo(state: S, {payload}: PayloadAction<Partial<ITableReportDocumentUploadInfo>>) {
        state.documentUploadInfo = {
            ...(state.documentUploadInfo),
            ...payload,
        };
    },
    setReportRequestData(state: S, {payload}: PayloadAction<ITableReportDataRequestParams>) {
        state.documentUploadInfo = {
            ...state.documentUploadInfo,
            reportRequestData: payload,
        };
    },
    updateReportDownloadsPagination(state: S, {payload: pagination}: PayloadAction<Partial<IPaginationType>>) {
        if (state.reportDownloadDocuments) {
            state.reportDownloadDocuments = {
                ...state.reportDownloadDocuments,
                ...pagination,
            };
        }
    },
    setReadReportDownloadDocuments(state: S, {payload}: PayloadAction<TReadReportDocumentsParams>) {
        if (state.reportDownloadDocuments) {
            state.reportDownloadDocuments = {
                ...state.reportDownloadDocuments,
                modalReportDownloadDocument: {
                    ...state.reportDownloadDocuments?.modalReportDownloadDocument,
                    wereDocumentsRead: payload?.wereDocumentsRead,
                    isAnimationActive: payload?.isAnimationActive,
                },
            };
        }
    },
    setAnimationReportDownloadDocuments(state: S, {payload}: PayloadAction<TAnimationReportDownloadDocumentsParams>) {
        if (state.reportDownloadDocuments) {
            state.reportDownloadDocuments = {
                ...state.reportDownloadDocuments,
                modalReportDownloadDocument: {
                    ...state.reportDownloadDocuments?.modalReportDownloadDocument,
                    isAnimationActive: payload?.isAnimationActive,
                },
            };
        }
    },
    setModalReportDownloadDocuments(state: S, {payload}: PayloadAction<IModalReportDownloadDocumentType>) {
        if (state.reportDownloadDocuments) {
            state.reportDownloadDocuments = {
                ...state.reportDownloadDocuments,
                modalReportDownloadDocument: {
                    ...state.reportDownloadDocuments?.modalReportDownloadDocument,
                    isOpen: payload.isOpen,
                    wereDocumentsRead: payload?.wereDocumentsRead,
                },
            };
        }
    },
});
